import { useCallback, useState } from 'react'

export const usePopupOpenedState = () => {
  const [isPopupOpened, setOpened] = useState<boolean>(false)
  const visibilityCallbackHandler = useCallback((newValue: boolean) => {
    setOpened(newValue)
    return newValue
  }, [])

  return { isPopupOpened, visibilityCallbackHandler }
}
